import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomButton, CustomImage, CustomModal, Text, useText } from '@src/components';

import { Header } from '@src/components/CustomDialog';

import { Radio, Space } from 'antd';
import { setPayWithLinkinEmail } from '@src/store/slice/mobilExpressSlice';

import { instructionAdd, nextStep } from '@src/store/slice/autoUploadInstructionsSlice';

import modalClose from '@src/assets/icons/icon-close.svg';
import modalWarning from '@src/assets/icons/icon-modal-warning.svg';

import './payWithNewCardAutoUpload.scss';

const PayWithNewCardAutoUpload = ({ setModalVisible, saveAction, form }) => {
  const dispatch = useDispatch();
  const warningTitle = useText('warning2');

  const { totalAutoLoading, integrationId, autoLoadingId } = useSelector(
    (state) => state?.autoUploadInstructions,
  );

  const [value, setValue] = useState(0);
  const [selectedType, setSelectedType] = useState(null);

  const sendLinkPayment = useCallback(async () => {
    const body = {
      autoLoadingCreateRequestDto: {
        periodType: totalAutoLoading?.periodType,
        confirmEveryMonth: totalAutoLoading?.confirmEveryMonth,
        startDay: totalAutoLoading?.startDay,
        orderProcessType: totalAutoLoading?.orderProcessType,
        monthChoice: totalAutoLoading?.chooseMonth,
        isLinkPayment: true,
      },
    };

    if (integrationId && integrationId > 0) {
      body.integrationId = integrationId;
    }

    if (autoLoadingId && autoLoadingId > 0) {
      body.autoLoadingId = totalAutoLoading?.id;
    }

    const action = await dispatch(instructionAdd(body));

    if (instructionAdd.fulfilled.match(action)) {
      dispatch(nextStep());
    }
  }, [dispatch, totalAutoLoading, integrationId, autoLoadingId]);

  const handler = async () => {
    if (value === 1) {
      try {
        await form.setFieldsValue({
          cardSaveChecked: true,
        });
        await form.validateFields();
      } catch (e) {
        setModalVisible(false);
      }
      await dispatch(setPayWithLinkinEmail(false));
      await saveAction();
    } else {
      setModalVisible(false);
      sendLinkPayment();
    }
  };

  const onChange = useCallback(
    async (e) => {
      setSelectedType(e.target.value);
      setValue(e.target.value);
      if (e.target.value === 1) await form.validateFields();
    },
    [selectedType],
  );

  return (
    <CustomModal
      className="pay-with-new-card pay-with-new-card-auto-upload"
      maskClosable={false}
      footer={false}
      title={<Header title={warningTitle} type={'warning'} icon={modalWarning}></Header>}
      visible={true}
      onCancel={async () => {
        setModalVisible(false);
      }}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className={'modal-inner-container'}>
        <div className={'text-1'}>
          <div>
            <Text t="yourPaymentWillBeCollectedFromYouRegularly" />
          </div>
          <div style={{ marginTop: '12px' }}>
            <Text t="youCanSaveYourCardInformationToComplete" />
          </div>
        </div>
        <div className={'custom-radio-input-content'}>
          <Radio.Group
            id="ticketRestaurant-paymentModal-payWithNewCard-payWithNewCard-custom-radioGroup-input-content"
            onChange={(e) => {
              onChange(e);
              e.preventDefault();
              e.stopPropagation();
            }}
            value={value}
          >
            <Space direction="vertical">
              <Radio
                id="ticketRestaurant-paymentModal-payWithNewCard-payWithNewCard-custom-radio-input-content-1"
                value={1}
              >
                <span className={'option-label'}>
                  <Text t="saveMyCardAndCollectPaymentFromThis" />
                </span>
              </Radio>
              <Radio
                id="ticketRestaurant-paymentModal-payWithNewCard-payWithNewCard-custom-radio-input-content-2"
                value={2}
              >
                <div className={'option-label'} style={{ margin: '10px 0' }}>
                  <Text t="saveMyCardInformationAndSendMeA" />
                </div>
              </Radio>
            </Space>
          </Radio.Group>
        </div>
        <CustomButton
          id="ticketRestaurant-paymentModals-payWithNewCard-payWithNewCard-pay-now"
          disabled={value === 0}
          className="pay-now"
          onClick={() => handler()}
        >
          <Text t="continue" />
        </CustomButton>
      </div>
    </CustomModal>
  );
};

export default PayWithNewCardAutoUpload;
